<template>
  <v-container >
    <p class="title	">
        Adicione cada membro, com seu respectivo CPF, abaixo.
    </p>
    <v-layout justify-center wrap>
      <template>
        <v-flex xs6 md6>
          <v-text-field
            v-model="cpf_consulta"
            class="purple-input"
            label="Digite o CPF do membro"
            v-mask="'###.###.###-##'"
          />
        </v-flex>
        <v-flex xs2 md2 align-self-center>
          <v-btn fab small dark  color="indigo" @click="search_person">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-flex>
      </template>

      <template v-if="persons.length>0">
       

        <v-flex xs12 md12>
          <v-form>
           <v-expansion-panels class="elevation-0" v-model="panel" multiple color="grey">
              <v-expansion-panel
                v-for="(person, index) in persons"
                :key="person.row_count"
              >

               <v-expansion-panel-header><div>
                    <strong>
                      {{index + 1}}
                      <template v-if="person.name">- {{person.name}} </template>
                      <template v-if="person.last_name">{{person.last_name}}</template>
                    </strong>
                  </div></v-expansion-panel-header>


              <v-expansion-panel-content
                class="px-3 elevation-0"
               
              >
                <v-divider></v-divider>

                <v-layout wrap class="my-1">
                  <v-flex xs12 md5>
                    <v-text-field v-model="person.name" class="purple-input" label="Primeiro nome" />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="person.lastname"
                      class="purple-input"
                      label="Sobrenome"
                    />
                  </v-flex>

                  <v-flex xs12 md1>
                    <v-btn fab dark small color="error" @click="remove_person(person)">
                      <v-icon dark>remove</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="person.cpf"
                      class="purple-input"
                      label="CPF"
                      v-mask="'###.###.###-##'"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      v-model="person.pivot.share"
                      class="purple-input"
                      label="Participação"
                      messages='A porcentagem que essa pessoa tem sobre o artista.'
                      suffix="%"
                      v-money="moneyk"
                    />
                  </v-flex>

                  <!--Dados Bancários-->
                  <v-flex xs12 md6 v-if="!is_company">
                    <v-autocomplete
                        v-model="person.bank"
                        :items="$store.getters.configs.banks"
                        item-text="name"
                        item-value="id"
                        label = "Banco"
                        messages="Digite o nome do Banco"
                    />
                  </v-flex>

                  <v-flex xs12 md3 v-if="!is_company">
                    <v-text-field
                      class="purple-input"
                      label="Agência"
                      messages="Digite a agência sem digito verificador"
                      v-model="person.bank_agency"
                    />
                  </v-flex>
                  <v-flex xs12 md3 v-if="!is_company">
                    <v-text-field
                      class="purple-input"
                      label="Conta"
                      messages="Digite a conta do seu banco com o digito verificador"
                      v-model="person.bank_account"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-flex>
      </template>
    </v-layout>
     <modalmessage ref="modalmessage" />
  </v-container>
</template>

<script>
import modalmessage from "../../../src/components/shared/modalmessage";
export default {
  components: { modalmessage },
  data() {
    return {
      count_persons: 0,
      panel: [0,1,2,3,4],
      persons: [], //{ row_count: 0, expanded: true }
      items: [],
      select: null,
      cpf_consulta: '',
      moneyk: {
            decimal: ".",
            thousands: "",
            precision: 2,
            masked: true /* doesn't work with directive */
        }
    };
  },
  props: {
    personsdata: Array,
    is_company: Number,
    artist_type: String
  },
  watch: {
    persons: function() {
      this.$emit("persons_data", this.persons);
      
    },
    personsdata: function() {  
      console.log("personsdata")  ;
      console.log(this.personsdata)
    }
  },
  created(){
   this.persons = this.personsdata.map( e=>{ e.row_count = this.count_persons++; if(e.pivot==undefined){e.pivot={share:''}} return e; })
  },
  methods: {
    search_person: function() {
      if (this.cpf_consulta.length == 14) {
        if (this.artist_type === 'dupla' && this.personsdata.length >= 2) {
            this.$refs.modalmessage.show(
                "Atenção",
                `Uma dupla é composta por apenas 2 integrantes`,
                "entendi"
            );
          return
        } else {
          this.add_person(null);
        }
      } else  if( this.cpf_consulta == null || this.cpf_consulta.length < 14) {
        this.$refs.modalmessage.show(
                "Atenção",
                "Tamanho mínimo do CPF não atendido",
                "entendi"
            );
      }
    },
    //Adiciona uma pessoa ao conjunto atual
    add_person: function(tp_person) {
      this.count_persons = this.count_persons + 1;
      
      console.log("add_person inicial", tp_person,this.count_persons);
      
      if (tp_person != null) {
        tp_person.row_count = this.count_persons;
        //se nao houver o pivot, criamos um temporario
        if (tp_person.pivot == null) {
          tp_person.pivot = { share: "" };
        }

        console.log("add_person meio_if", tp_person,this.count_persons);

      } else {
        tp_person = {};
        
        

        tp_person = {
          row_count: this.count_persons,
          cpf: this.cpf_consulta,          
          pivot: {share:""}
        };

        console.log("add_person meio_else", tp_person,this.count_persons);

      }
      
      this.persons.push(Object.assign({}, tp_person));
      
      this.cpf_consulta = "";
      console.log("add_person final", tp_person,this.count_persons);
      return;
    },
    remove_person: function(indice) {
      var t_faixas = [];
      this.persons.forEach(element => {
        if (indice.row_count != element.row_count) {
          t_faixas.push(element);
        }
      });
      this.persons = [...t_faixas];
      this.count_persons = (this.count_persons - 1) < 0 ? 0 : this.count_persons - 1;
      console.log('remove_person', this.persons);
    }
  }
};
</script>